import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const adminModules = [
  { title: 'Alumnos', description: 'Gestionar alumnos y sus historiales', path: '/admin/students' },
  { title: 'Cinturones', description: 'Administrar cinturones y documentos', path: '/admin/belts' },
  { title: 'Eventos', description: 'Crear y gestionar eventos', path: '/admin/events' },
  { title: 'Administradores', description: 'Gestionar usuarios administradores', path: '/admin/admins' },
  { title: 'Contenido', description: 'Editar páginas institucionales', path: '/admin/content' },
  { title: 'Tarifas', description: 'Publicar tarifas en PDF o Markdown', path: '/admin/tariffs' },
];

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="admin-page">
      <header className="mb-8">
        <h1 className="admin-title">Panel de administración</h1>
        <p className="mt-2 text-muted">
          Bienvenido, {user?.first_name} {user?.last_name}
        </p>
      </header>

      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {adminModules.map((module) => (
          <li key={module.path}>
            <article className="flex h-full flex-col rounded-lg border border-line bg-surface p-5">
              <h2 className="text-lg font-semibold text-ink">{module.title}</h2>
              <p className="mt-2 flex-1 text-sm text-muted">{module.description}</p>
              <button type="button" className="btn-admin mt-5 w-full" onClick={() => navigate(module.path)}>
                Acceder
              </button>
            </article>
          </li>
        ))}
      </ul>

      <p className="mt-10 text-center text-xs text-muted">
        Última sesión: {new Date().toLocaleString('es-AR')}
      </p>
    </div>
  );
};

export default Dashboard;
